import routeName from '../constant';

const routes = [
    {
        path: 'dividend-change',
        name: routeName.DIVIDEND_CHANGE,
        component: () => import('@/views/aplCatl640and631/B2/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '紅利/增值回饋分享金給付方式變更', leaveAlert: true, code: 'B2', unableBack: true },
    }];

export default routes;
